import { TARIFF_TYPES, EV_TOU_DEFINITION } from 'config/app-config';

import { TProduct } from 'api/models/TProduct';

export const getTariffType = (product: TProduct) => {
  const { electricityTil, gasTil, touDefinition } = product;
  const tariff = electricityTil || gasTil;
  const tariffType = tariff?.tariffType;

  return {
    tariffType,
    isFixed: tariffType === TARIFF_TYPES.FIXED,
    isVariable: tariffType === TARIFF_TYPES.VARIABLE,
    isTracker: tariffType === TARIFF_TYPES.TRACKER,
    isEV: touDefinition === EV_TOU_DEFINITION
  };
};

export const useTariffType = (product: TProduct = {}) => {
  return getTariffType(product);
};
